/**
 * Whether rich-text HTML holds nothing an author would call content.
 *
 * Tiptap represents an untouched document as `<p></p>`, so an empty editor is not an
 * empty string — every caller that asks "has anything been written?" has to know
 * that, which is why it is answered in one place.
 *
 * Only WHOLE empty paragraphs are removed, matched as a unit. Stripping tags
 * piecemeal is the version of this that gets it wrong: one pass over `<p><br></p>`
 * removes the `<br>` and leaves `<p></p>` behind, which then reads as content.
 *
 * Anything else — a heading, an image, a palette block — leaves residue and counts
 * as content, which is the correct answer for a document whose meaning is not text.
 */
const EMPTY_PARAGRAPH = /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/g

export function isEmptyRichText(html: string): boolean {
	return html.replace(EMPTY_PARAGRAPH, '').trim() === ''
}
